import { render } from "./sell-voucher.vue?vue&type=template&id=a6354eb0"
import script from "./sell-voucher.vue?vue&type=script&lang=js"
export * from "./sell-voucher.vue?vue&type=script&lang=js"
script.render = render

export default script